import { Button, IllustrativeIcon, Surface, Txt } from '@vst/beam';
import { PersonWithHeadset } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import styles from './NoAppointmentsAvailable.module.scss';

type NoAppointmentsAvailableProps = {
  navigateToPreviousPage?: () => void;
  className?: string;
  description: string | React.ReactElement;
};

export const NoAppointmentsAvailable = ({
  className = '',
  navigateToPreviousPage,
  description,
}: NoAppointmentsAvailableProps) => {
  const { t } = useTranslation('ScheduleInstallation', {
    keyPrefix: 'NoAppointmentsAvailable',
  });

  return (
    <Surface
      className={`${styles['wrapper']} ${className}`}
      px={{ xs: '16px', md: '112px' }}
      my={{ xs: undefined, sm: '40px' }}
      radius="16px"
    >
      <IllustrativeIcon
        name="PersonWithHeadset"
        icon={PersonWithHeadset}
        color="teal_600"
        width={80}
        height={80}
        data-cy="Person-Icon"
      />

      <Txt
        variant="heading6"
        data-cy="NoAppointmentsAvailable-title"
        mt="24px"
        mb="16px"
      >
        {t('title')}
      </Txt>

      <Surface
        className={styles['description']}
        data-cy="NoAppointmentsAvailable-description"
      >
        <Txt variant="linkBodySmall" style={{ textAlign: 'center' }}>
          {description}
        </Txt>
      </Surface>

      {navigateToPreviousPage && (
        <Button
          data-cy="NoAppointmentsAvailable-button"
          className={styles['backToMyViasat']}
          onClick={navigateToPreviousPage}
          fluid
        >
          {t('goBack')}
        </Button>
      )}
    </Surface>
  );
};
